module.exports = __webpack_public_path__ + "static/media/warehouse.3b11a61b.png";